<template>
  <div class="service-utilize-container">
    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="서비스 이용 매출 정보" :useTab="false" v-if="total_price">
            <div class="columns">
              <div class="column is-full">
                <div class="grid-row">
                  <div class="grid-title">총 이용 금액</div>
                  <div class="grid-content">{{ total_price.utilize|currency }}</div>
                </div>
                <div class="grid-row">
                  <div class="grid-title">총 결제 금액</div>
                  <div class="grid-content">{{ total_price.account|currency }}</div>
                </div>
                <div class="grid-row">
                  <div class="grid-title">총 충전금</div>
                  <div class="grid-content">{{ total_price.charge|currency }}</div>
                </div>
                <div class="grid-row">
                  <div class="grid-title">충전금 사용 잔액</div>
                  <div class="grid-content">{{ total_price.charge_remain|currency }}</div>
                </div>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-full">
        <div class="flex-end">
          <button class="button is-primary" @click="clickReg">수기 등록</button>
        </div>
      </div>

      <div class="column is-full">
        <admin-filter
          :items="filterData"
          :itemFiltered.sync="filtered"
          @getData="getDataFromServer"
          title="이용결제내역 조회"
          ref="admin_filter"></admin-filter>
      </div>
      <div class="column is-full">
        <admin-table :field_list="tableData"
                     :items="tableItems"
                     :filtered="filtered"
                     :allCount="allCount"
                     :filteredCount="filteredCount"
                     :table_width="1808"
                     @getData="getDataFromServer"
                     @ordering="ordering"
                     @selPageLength="selPageLength">
          <div slot="billing_date" slot-scope="props">{{ datesFormat(props.item.billing_date, 'date_3') }}</div>
          <div slot="service_name" slot-scope="props">
            <div style="text-decoration: underline;cursor: pointer"
                 @click="clickService(props.item.service)">{{ props.item.service.service_name }}</div>
          </div>
          <div slot="end_date" slot-scope="props">{{ datesFormat(props.item.end_date, 'date_3') }}</div>
          <div slot="product_price" slot-scope="props">{{ currency(props.item.product_price) }}</div>
          <div slot="account_price" slot-scope="props">{{ currency(props.item.account_price) }}</div>
          <div slot="pay_method" slot-scope="props">{{ pay_method_kor(props.item.pay_method) }}</div>
          <div slot="billing_status" slot-scope="props">{{ billing_status_kor(props.item.billing_status) }}</div>
          <div slot="status" slot-scope="props">{{ status_kor(props.item.status) }}</div>
          <div slot="account_date" slot-scope="props">{{ datesFormat(props.item.account_date, 'date_3') }}</div>
          <div slot="taxbill_date" slot-scope="props">{{ datesFormat(props.item.taxbill_date, 'date_3') }}</div>
          <div slot="invoice_date" slot-scope="props">{{ datesFormat(props.item.invoice_date, 'date_3') }}</div>
          <div slot="update" slot-scope="props">
            <button class="button" @click="clickItem(props.item)" style="width:68px">수정하기</button>
          </div>
        </admin-table>
      </div>

    </div>
    <modal-utilize ref="utilModal"
                   :updateItem="selectedItem"
                   :service_id="selectedService"
                   @close="onCloseModal"></modal-utilize>
  </div>
</template>

<script>
  import Pagination from "../../../module/common/Pagination";
  import ModalUtilize from "./components/ModalUtilize";
  import ListMixin from "../../../../mixins/ListMixin";
  export default {
    name: 'ServiceUtilizeAll',
    components: {ModalUtilize, Pagination},
    mixins: [
      ListMixin
    ],
    created() {
      this.init();
    },
    data() {
      return {
        option: {
          pay_method: [
            {value: 0, label: '빌링결제(이니시스)', checked: false},
            {value: 1, label: '계좌이체', checked: false},
            {value: 2, label: '빌링결제(페이플)', checked: false},
            {value: 3, label: '충전금 소진', checked: false}
          ],
          category: [],
          status: [
            {value: '', label: '전체'},
            {value: 0, label: '결제대기'},
            {value: 1, label: '결제완료'},
            {value: 2, label: '입금완료'}
          ],
          billing_status: [
            {value: 0, label: '청구대기'},
            {value: 1, label: '청구완료'}
          ]
        },
        total_price: {
          utilize: 0,
          account: 0,
          charge: 0,
          charge_remain: 0
        },
        selectedItem: undefined,
        selectedService: 0
      }
    },
    methods: {
      clickService(service) {
        this.routerPush(`/office/admin/launchpack/utilize/service?id=${service.id}`);
      },
      pay_method_kor(item) {
        return this.option.pay_method.filter(i => i.value === item)[0].label;
      },
      status_kor(item) {
        return this.option.status.filter(i => i.value === item)[0].label;
      },
      billing_status_kor(item) {
        return this.option.billing_status.filter(i => i.value === item)[0].label;
      },
      getDataFromServer() {
        this.getService();
      },
      async init() {
        // 카테고리
        let res = await this.$axios.get('public/category?parent_id=50');
        res.data.splice(0,0, {
          name: '전체',
          id: ''
        })
        this.option.category = res.data.map(i => {
          return {
            label: i.name,
            value: i.id
          }
        });
        this.initializing('launchpack_service_utilize_all', 'launchpack/service/utilize');
        // 기간 시작을 올해 1월 1일로.
        this.filtered.start = `${this.moment().format('YYYY-')}01-01`;
        this.filterData.find(i => i.type === 'period').start = this.filtered.start;
        // 결제일 정렬
        this.filtered.ordering = '-billing_date';
        this.$nextTick(()=>{
          let items = this.$refs.admin_filter.items;
          items.find(i => i.key === 'category').options = this.option.category;
          items.find(i => i.key === 'pay_method').options = this.option.pay_method;
          items.find(i => i.key === 'status').options = this.option.status;
        });
        this.getService();
      },
      clickItem(item) {
        this.selectedItem = item;
        this.selectedService = item.service.id;
        this.$refs.utilModal.open();
      },
      clickReg() {
        this.selectedItem = undefined;
        this.$refs.utilModal.open();
      },
      async getService() {
        let params = {};
        if(this.filtered.start && this.filtered.start !== '') {
          params['billing_date__start'] = this.filtered.start;
        }
        if(this.filtered.end && this.filtered.end !== '') {
          params['billing_date__end'] = this.filtered.end;
        }
        let res = await this.$axios.get(this.getUrl(`launchpack/service/utilize_info`), {params: params});
        this.total_price = res.data;
        this.getData();
      },
      onCloseModal() {
        this.getData();
      }
    }
  }
</script>

<style lang="stylus" scoped>
  $background2=#f5f5f5
  $border-main=#dddddd
  $border-sub=#eeeeee
  $primary=#ff5722

  .grid-row
  .grid-row-end
    display grid
    grid-column-gap 8px
    font-size 14px
    margin-bottom 8px
    align-items center

  .grid-row
    grid-template-columns 120px 1fr

  .grid-row-end
    grid-template-columns 1fr 90px
    text-align right

  .grid-title
    font-weight 600

  .button
    width 100px

  .check-box
    input
      margin-right 4px
      vertical-align middle
      border 1px solid #dddddd

  .service-utilize-container
    table
      width 100%
      border 1px solid $border-main
      th
      td
        vertical-align middle
        text-align center
        border 1px solid $border-main
        padding 4px 8px
      th
        background-color $background2
      tr:hover
        background-color #ff572210
        cursor pointer
</style>
<style lang="stylus">
  .lp-date-picker
    margin-bottom 0 !important
  .mx-datepicker
    width 130px
  .title-group
    margin-bottom 12px !important
</style>
